import { useState } from 'react';

const useRechargeBalance = () => {
  const [value, setValue] = useState(0);
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return { value, handleChange };
};

export default useRechargeBalance;
